import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-134">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-navy-900/40 via-dark-900 to-dark-900 -z-10" data-id="element-135"></div>
      <div className="max-w-5xl mx-auto text-center" data-id="element-136">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-137">
          EL ANTI-MANUAL DE LA IA: <br data-id="element-138" />
          <span className="text-gold-500" data-id="element-139">
            Blindaje Humano en la Era de la Automatización
          </span>
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto font-light" data-id="element-140">
          Deja de competir contra el silicio y recupera el valor que ninguna
          máquina podrá procesar jamás.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mb-12" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/cHem7FeV8hPwLg8VRhTGRT/ChatGPT_Image_17_abr_2026,_12_46_32.png" alt="El Anti-Manual de la IA" className="mx-auto max-w-full h-auto rounded-lg shadow-2xl shadow-gold-500/10 md:max-w-3xl" data-id="element-142" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="max-w-3xl mx-auto text-left space-y-6 text-lg text-gray-300" data-id="element-143">
          <p data-id="element-144">
            El lunes por la mañana abres tu correo y sientes ese frío seco en el
            pecho. Sabes que allá afuera hay un software que hace lo que tú
            haces, pero 1,000 veces más rápido y por un céntimo de dólar. No es
            paranoia, es la realidad de un mercado que ha dejado de valorar la
            "eficiencia" humana porque las máquinas ya ganaron esa carrera.
          </p>
          <p data-id="element-145">
            Si sientes que tu título, tu experiencia y tu esfuerzo diario se
            están volviendo invisibles, es porque te han entrenado para ser un
            algoritmo biológico. Y a los algoritmos, hoy en día, se les
            reemplaza con un clic.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-12" data-id="element-146">
          <a href="#offer" data-id="element-147">
            <Button className="text-lg w-full md:w-auto" data-id="element-148">
              RECLAMAR MI BLINDAJE HUMANO AHORA
            </Button>
          </a>
        </motion.div>
      </div>
    </section>;
}